import { useUser } from '@clerk/clerk-react'
import { Alert, Button, Stack } from '@mui/material'
import type { ReactNode } from 'react'

const Protect = ({
  children,
  fallback,
  roles
}: {
  children: ReactNode
  fallback?: ReactNode
  roles?: UserPublicMetadata['roles']
}) => {
  const { isSignedIn, user } = useUser()

  if (!isSignedIn) return fallback
  if (!user.publicMetadata.roles) return fallback
  if (roles && !user.publicMetadata.roles.some(role => roles.includes(role))) return fallback
  if (import.meta.env.VITE_VERCEL_ENV === 'production' && !user.twoFactorEnabled)
    return (
      <Stack gap={2} sx={{ alignItems: 'center' }}>
        <Alert severity='warning'>Please enable two factor authentication</Alert>
        <Button
          color='success'
          variant='outlined'
          onClick={() => window.Clerk.openUserProfile({ __experimental_startPath: '/security' })}
        >
          Click here for adding 2FA
        </Button>
      </Stack>
    )

  return children
}

export default Protect
